import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '~shared/constants/api.config';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class ImpersonationService {

  constructor(private http: HttpClient) {
  }

  exchangeCodeToAccessToken(params: object) {
    const url = `${ApiConfig.SVC_IMS_ENDPOINT()}/admin/impersonation/exchange`;
    return this.http.post(url, params, {
      // withCredentials: true
    });
  }
}
